import React, { useEffect, useState } from 'react'
import './style.scss'

interface CopyProps {
  text: string
}

const Copy: React.FC<CopyProps> = ({ text }) => {
  const [status, setStatus] = useState<response.StatusTypes>('idle')

  useEffect(() => {
    if (status === 'failed' || status === 'succeed') {
      const timeout = setTimeout(() => {
        setStatus('idle')
      }, 2_000)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [status])

  const generateIcon = () => {
    switch (status) {
      case 'idle': return <i
        className='icon icon--copy s16'
        onClick={() => {
          copyToClipboard(text, setStatus)
        }} />
      case 'pending': return <i className='icon icon--copy s16' />
      case 'succeed': return <i className='icon icon--check s16' />
      case 'failed': return <i className='icon icon--close s16' />
    }
  }

  return (
    <span className='copyText'>
      {generateIcon()}
    </span>
  )
}

const copyToClipboard = (text: string, onCallback: (status: response.StatusTypes) => void) => {
  onCallback('pending')
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).then(() => {
      onCallback('succeed')
    }).catch(err => {
      onCallback('failed')
      console.error('Błąd podczas kopiowania:', err)
    })

  } else {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        onCallback('succeed')
      } else {
        throw new Error('Nie udało się skopiować tekstu.')
      }
    } catch (err) {
      onCallback('failed')
      console.error('Błąd podczas kopiowania: ', err)
    }

    document.body.removeChild(textarea)
  }
}

export default Copy